export default {
  manage: {
    label: 'Visites guidées',
    desc: 'Gérer les visites guidées',
    reset: 'Revoir la visite guidée',
    completed: 'Terminée',
    pristine: 'Non effectuée',
    activate: 'Activer les visites guidées',
    deactivateInfo: 'Vous pouvez accéder à votre profil pour réactiver toutes les visites guidées.'
  },
  buttons: {
    next: 'Continuer',
    prev: 'Retour',
    done: 'Fermer la visite guidée',
    deactivate: 'Désactiver les visites'
  },
  tour: {
    patient: {
      header: {
        serviceTitle: 'Votre service de soins',
        serviceDesc: 'Ce service est responsable de votre accompagnement médical. Il centralise vos informations, coordonne vos soins et vous transmet les documents ou messages utiles à votre parcours de santé.',
        notificationsTitle: 'Centre de notifications',
        notificationsDesc: 'Consultez vos nouvelles notifications concernant votre suivi.',
        profileTitle: 'Profil et paramètres',
        profileDesc: 'Accédez à vos informations de compte et à vos paramètres.'
      },
      tabs: {
        label: 'Onglets de l\'espace patient',
        tasksTitle: 'Mes Tâches',
        tasksDesc: 'Vos actions du jour à réaliser.',
        monitoringTitle: 'Mon Suivi',
        monitoringDesc: 'Votre suivi et vos mesures.',
        agendaTitle: 'Mon Agenda',
        agendaDesc: 'Vos rendez-vous et événements.',
        messengerTitle: 'Ma Messagerie',
        messengerDesc: 'Échangez avec l\'équipe soignante.',
        documentsTitle: 'Mes Documents',
        documentsDesc: 'Tous vos documents.'
      },
      tasks: {
        label: 'Mes tâches',
        title: 'Mes tâches',
        desc: 'Retrouvez ici vos actions à réaliser : questionnaires, rendez-vous et documents à consulter.',
        counterTitle: 'Compteur de tâches',
        counterDesc: 'Le nombre d\'activités planifiées à réaliser aujourd\'hui et le nombre d\'activités libres.',
        priorityTitle: 'En priorité',
        priorityDesc: 'Les actions les plus importantes ou en retard s\'affichent ici.',
        todayTitle: 'Planifiées aujourd\'hui',
        todayDesc: 'Les actions planifiées pour aujourd\'hui s\'affichent ici.',
        upcomingTitle: 'À venir',
        upcomingDesc: 'Les prochaines actions planifiées s\'affichent ici.',
        freeTitle: 'Activités libres',
        freeDesc: 'Des questionnaires facultatifs que vous pouvez remplir à tout moment.',
        cleanupAlert: 'Les données de démonstration des tâches ont été supprimées.',
        congratsTitle: 'Félicitations !',
        congratsDesc: 'Vous avez terminé la visite guidée des tâches. Vous pouvez maintenant utiliser cette section en toute autonomie.'
      },
      events: {
        label: 'Mon agenda',
        title: 'Mon agenda',
        desc: 'Visualisez vos questionnaires planifiés, rendez-vous et documents à consulter pour la date choisie.',
        schedulerTitle: 'Calendrier',
        schedulerDesc: 'Sélectionnez une date pour afficher les activités prévues ce jour-là.',
        listTitle: 'Activités du jour',
        listDesc: 'Consultez vos questionnaires, rendez-vous et documents planifiés pour cette date.',
        addTitle: 'Ajouter une activité',
        addDesc: 'Planifiez un questionnaire, un rendez-vous ou ajoutez un rappel pour une date donnée.',
        cleanupAlert: 'Les données de démonstration de l\'agenda ont été supprimées.',
        outroTitle: 'Félicitations !',
        outroDesc: 'Vous savez maintenant utiliser votre agenda.'
      },
      documents: {
        label: 'Mes documents',
        title: 'Mes documents',
        desc: 'Retrouvez ici vos documents personnels et les ressources partagées par l\'équipe.',
        filterTitle: 'Filtres de recherche',
        filterDesc: 'Si vous avez beaucoup de documents, affinez l\'affichage en utilisant les outils de recherche et de tri.',
        listTitle: 'Liste des documents',
        listDesc: 'Appuyez sur un document pour l\'ouvrir, le consulter ou le télécharger.',
        addTitle: 'Ajouter un document',
        addDesc: 'Téléchargez un fichier ou prenez une photo pour l\'ajouter à vos documents.',
        cleanupAlert: 'Les données de démonstration des documents ont été supprimées.',
        outroTitle: 'Félicitations !',
        outroDesc: 'Vous savez maintenant où trouver vos documents.'
      },
      messages: {
        label: 'Ma messagerie',
        title: 'Ma messagerie',
        desc: 'Échangez avec votre équipe soignante, consultez et envoyez des messages.',
        addTitle: 'Envoyer un message',
        addDesc: 'Rédigez votre message, joignez un fichier si nécessaire, puis appuyez sur Envoyer.',
        cleanupAlert: 'Les données de démonstration de la messagerie ont été supprimées.',
        outroTitle: 'Félicitations !',
        outroDesc: 'Vous savez maintenant utiliser la messagerie.'
      },
      monitoring: {
        label: 'Mon suivi',
        title: 'Mon suivi',
        desc: 'Visualisez vos mesures, votre contenu éducatif et votre historique.',
        graphsTitle: 'Mes données',
        graphsDesc: 'Retrouvez ici vos mesures récentes sous forme de graphiques.',
        contentTitle: 'Contenu thérapeutique',
        contentDesc: 'Des vidéos, articles et documents pour vous accompagner.',
        historyTitle: 'Historique',
        historyDesc: 'Vos actions récentes : réponses aux questionnaires et consultations de documents.',
        cleanupAlert: 'Les données de démonstration du suivi ont été supprimées.',
        outroTitle: 'Félicitations !',
        outroDesc: 'Vous savez maintenant où retrouver votre suivi.'
      },
      home: {
        label: 'Page d\'accueil',
        welcomeTitle: 'Bienvenue dans Aptelecare !',
        welcomeDesc: 'Nous allons vous guider pour découvrir les fonctionnalités de votre espace patient, afin que vous puissiez suivre vos informations de santé facilement et en toute sérénité.\n\n**Des données factices peuvent apparaître, pas d\'inquiétude : elles seront supprimées automatiquement à la fin de la visite**.',
        countersTitle: 'Synthèse de votre activité',
        countersDesc: 'Suivez facilement l\'avancement de votre parcours : consultez vos tâches à accomplir, vos nouveaux messages et les documents partagés par votre équipe médicale.',
        tasksTitle: 'Mes Tâches',
        tasksDesc: 'Retrouvez ici les actions à réaliser : questionnaires, rendez-vous et documents à consulter.',
        monitoringTitle: 'Mon Suivi',
        monitoringDesc: 'Visualisez vos mesures et l\'évolution de votre suivi.',
        documentsTitle: 'Mes Documents',
        documentsDesc: 'Accédez à vos documents médicaux.',
        messagesTitle: 'Ma Messagerie',
        messagesDesc: 'Échangez en toute sécurité avec l\'équipe soignante.',
        agendaTitle: 'Mon Agenda',
        agendaDesc: 'Vos rendez-vous et événements.',
        outroTitle: 'Félicitations !',
        outroDesc: 'Vous connaissez maintenant votre espace patient. N\'hésitez pas à revenir régulièrement pour suivre vos informations de santé et rester en contact avec votre équipe médicale.'
      },
      fakeData: {
        // Events
        eventsFollowupFormName: 'Questionnaire de suivi',
        eventsFollowupFormLaterName: 'Questionnaire de suivi (plus tard)',
        eventsRendezVousTitle: 'Rendez-vous téléphonique',
        eventsRendezVousDescription: 'Avec votre infirmier(ère) référent(e).',
        eventsFreeFormOptionalName: 'Questionnaire suivi hebdomadaire ( facultatif)',
        eventsFreeFormName: 'Questionnaire suivi hebdomadaire',
        eventsPlannedDocumentName: 'Document d\'information',
        eventsPlannedDocumentFileName: 'Guide de préparation',
        eventsFollowupFormTomorrowName: 'Questionnaire de suivi (demain)',

        // Graphs
        graphsBpTitle: 'Tension artérielle',
        graphsIndicatorSystolicName: 'Systolique',
        graphsIndicatorDiastolicName: 'Diastolique',
        graphsWeightTitle: 'Poids',
        graphsIndicatorWeightName: 'Poids',

        // Messages
        messagesWelcome: 'Bonjour, bienvenue sur votre messagerie sécurisée. N\'hésitez pas à poser vos questions.',
        messagesQuestion: 'Merci ! Dois-je répondre au questionnaire aujourd\'hui ?',
        messagesAnswer: 'Oui, vous pouvez le compléter dès maintenant.',

        // Documents
        document1: 'Vidéo : Bien préparer mon rendez-vous',
        document2: 'Brochure : Informations pratiques',
        document3: 'Article : Conseils du quotidien',

        // Therapeutic content
        therapeuticContent1: 'Guide : Comprendre mon suivi',
        therapeuticContent2: 'Vidéo : Respiration et relaxation',

        // History
        historyFormName: 'Questionnaire de suivi'
      }
    }
  }
}
